import { OnInit, ElementRef, OnDestroy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatTableDataSource, MatSort, Sort, MatDatepicker, MatDialog } from '@angular/material';
import { MONTH_FORMATS, dateFormat_Month, dateFormat_Month2 } from 'src/app/share/utils/common-utils';
import { EsWarehouseService } from 'src/app/restapi/be-esquery';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { take, tap, takeUntil } from 'rxjs/operators';
import * as XLSX from 'xlsx';
import * as _moment from 'moment';
var moment = _moment;
var ɵ0 = MONTH_FORMATS;
var WarehouseTotalComponent = /** @class */ (function () {
    function WarehouseTotalComponent(fb, esWarehouseService, dialog) {
        this.fb = fb;
        this.esWarehouseService = esWarehouseService;
        this.dialog = dialog;
        this.dataList = [];
        this.dataSource = new MatTableDataSource([]);
        this.displayedColumns = ['recycle_place_name', 'give_good_cate', 'retrieve_sum', 'production_sum', 'event_production', 'storage_capacity',
            'center_cycle_product_before', 'center_cycle_product_after', 'shop_production', 'event_disposal', 'calculation_disposal', 'disposal_rate', 'shipping_sum'];
        this.minDate = moment().add(-1, 'year');
        this.maxDate = moment();
    }
    WarehouseTotalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.initForm();
        this.sort.sortChange.pipe(tap(function (sort) {
            _this.initPage(sort);
        }), takeUntil(componentDestroyed(this))).subscribe();
    };
    WarehouseTotalComponent.prototype.ngOnDestroy = function () { };
    WarehouseTotalComponent.prototype.initForm = function () {
        this.form = this.fb.group({
            date: moment().add(-1, 'month'),
            dept_info: null
        });
    };
    Object.defineProperty(WarehouseTotalComponent.prototype, "fc_date", {
        get: function () { return this.form.get('date'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WarehouseTotalComponent.prototype, "fc_deptInfo", {
        get: function () { return this.form.get('dept_info'); },
        enumerable: true,
        configurable: true
    });
    WarehouseTotalComponent.prototype.chosenMonthHandler = function (normalizedMonth, datepicker) {
        this.fc_date.setValue(normalizedMonth);
        this.search();
        datepicker.close();
    };
    WarehouseTotalComponent.prototype.selectDept = function (value) {
        if (!value || value == null) {
            this.fc_deptInfo.setValue(null);
            return;
        }
        this.fc_deptInfo.setValue(value);
        this.search();
    };
    Object.defineProperty(WarehouseTotalComponent.prototype, "date", {
        get: function () {
            return dateFormat_Month2(this.fc_date.value);
        },
        enumerable: true,
        configurable: true
    });
    WarehouseTotalComponent.prototype.initPage = function (sort) {
        if (!this.dataList)
            this.dataList = [];
        var sorted = this.dataList;
        if (sort) {
            sorted = this.dataList.sort(function (a, b) {
                var result = 0;
                if (a[sort.active] == undefined)
                    a[sort.active] = "";
                if (b[sort.active] == undefined)
                    b[sort.active] = "";
                if (a[sort.active] < b[sort.active])
                    result = -1;
                else if (a[sort.active] > b[sort.active])
                    result = 1;
                return result * (sort.direction === 'asc' ? 1 : -1);
            });
        }
        this.dataList = sorted;
        this.dataSource = new MatTableDataSource(this.dataList);
    };
    WarehouseTotalComponent.prototype.search = function () {
        this.totalGet();
    };
    WarehouseTotalComponent.prototype.exportTOExcel = function () {
        var ws = XLSX.utils.table_to_sheet(this.table.nativeElement);
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, '되살림터 종합 통계');
        XLSX.writeFile(wb, '되살림터 종합 통계.xlsx');
    };
    WarehouseTotalComponent.prototype.totalGet = function () {
        var _this = this;
        this.dataList = [];
        this.esWarehouseService.warehouseRecyclePlaceTotalStatisticalTableGet(dateFormat_Month(this.fc_date.value), dateFormat_Month(this.fc_date.value), this.fc_deptInfo.value != null ? this.fc_deptInfo.value.dept_id : null).pipe(take(1)).subscribe(function (res) {
            _this.dataList = res;
            _this.initPage(_this.sort);
        }, function (err) {
            console.error(err);
            _this.initPage(_this.sort);
        });
    };
    return WarehouseTotalComponent;
}());
export { WarehouseTotalComponent };
export { ɵ0 };
